import { render, staticRenderFns } from "./draftOrder.vue?vue&type=template&id=fa608698&"
import script from "./draftOrder.vue?vue&type=script&lang=js&"
export * from "./draftOrder.vue?vue&type=script&lang=js&"
import style0 from "./draftOrder.vue?vue&type=style&index=0&id=fa608698&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports